/**
 * The maximum amount of errors we're willing to report per page, assuming that reporting more than that amount is redundant.
 * @type {Number}
 */
export const MAX_ERRORS_PER_PAGE = 10;
